export default "__VITE_ASSET__CFIgm0ue__"